import AdvancedController from "./advanced-controller"

export default class AccordionController extends AdvancedController {

  static targets = [
    'item'
  ];

  static values = {
    firstOpen: Boolean,
    onlyOneCanBeOpen: Boolean
  }

  connect() {
    super.connect(...arguments)
    // TODO: currently only needed for messageItemConnected, 
    // there it could be a local var, but still keeping it as it might be needed later
    this._allItems = []
    this._activeItems = []
  }

  messageItemConnected(item) {
    this._allItems.push(item)
    if (this._allItems.length === 1 && this.firstOpenValue === true) {
      item.messageOpen();
    }
  }

  messageAddActive(newActive) {
    if (this.onlyOneCanBeOpenValue === true) {
      for (const oldActiveItems of this._activeItems) {
        oldActiveItems.messageClose();
      }
      this._activeItems = [newActive];
    }
  }

}
